/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { Dashboard } from './dashboard';
import { NotebookText } from 'lucide-react';

/**
 * Export `SkinNotes` component.
 */

export function SkinNotes(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.notes.base,
          icon: <NotebookText />,
          label: translate('notes.menu.notes')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
